module.exports = __webpack_public_path__ + "assets/img/networks-logo-dark-square.1c5ac517.svg";